module.exports = __webpack_public_path__ + "static/media/erogazione-servizi.201846b0.odt";